
import { useEffect, useRef } from "react";
import { EditorState, ResizeType } from "./EditorTypes";
import React from "react";
import { GetWBComponentByTypename } from "./Data/WBData";
import LayoutNode, { getNodeComponentAttributeValue, getNodeRootStyleAttributeValue, getNodeStyleAttributeValue } from "vagaro-website-rendering/src/components/Definitions/LayoutNode";
import { ResizeableType } from "./WBComponents/WBComponent";
import fadeInElement from "./Utilities/ElementAnimator";
import GetCanvasRelativeBounds from "./Utilities/GetCanvasRelativeBounds";
import { ScreenSize } from "vagaro-website-rendering/src/components/Definitions/ScreenSize";
import { wBComponentTypeNames } from "vagaro-website-rendering/src/components/Definitions/WBComponentTypeNames";



export default function SelectedOutline(props: {
  selectedTarget:{dom: HTMLElement,layout:LayoutNode}| null
  startResizeFunction: Function
  startAbsMoveFunction: Function
  editorState:EditorState
  canvasRef:React.RefObject<HTMLDivElement>
  screenSize:ScreenSize

}) {
  const prevDom = useRef<HTMLElement | null>();
  const [state,updateState] = React.useState(0);
  const thisDom = useRef(null);
  const containerDom = useRef<HTMLElement|null>(null);
  const horizontalLineRef = useRef(null);
  const verticalLineRef = useRef(null);

  const onResize = ()=>{
    updateState(state+1);
  
  }

  const onMutation = ()=>{

    if (!thisDom.current||!props.selectedTarget?.dom)
      return;

   
    let newbounds = GetCanvasRelativeBounds(props.selectedTarget.dom);
    let target = thisDom.current as HTMLElement
    target.style.height = newbounds.height + "px";
    target.style.width = newbounds.width + "px";
    target.style.top = newbounds.top + "px";
    target.style.left = newbounds.left + "px";

    if(horizontalLineRef.current&&verticalLineRef.current){

      let isLeft = true;
      let isTop = true;

      let href = horizontalLineRef.current as HTMLElement;
      let vref = verticalLineRef.current as HTMLElement;

      // if(href.style.right&&href.style.right!="")
      //   isLeft = false;
      // if(vref.style.bottom&&vref.style.bottom!="")
      //   isTop = false;

      const attatchType = getNodeComponentAttributeValue(props.selectedTarget.layout,"anchorType");




      if(attatchType==""){
        const rightVal = getNodeStyleAttributeValue(props.selectedTarget.layout,props.screenSize,"right");
        const bottomVal = getNodeStyleAttributeValue(props.selectedTarget.layout,props.screenSize,"bottom");

        if(rightVal!=""&&rightVal!="auto")
          isLeft = false;
        if(bottomVal!=""&&bottomVal!="auto")
          isTop = false;
      }
      else{
        if(attatchType.includes("right"))
          isLeft = false;
        if(attatchType.includes("bottom"))
          isTop = false;
      }


      const offset = getOffsetBounds(isLeft,isTop);
      href.style.width = offset.x+"px";
      vref.style.height = offset.y+"px";

      if(isTop){
        vref.style.bottom = "100%";
        vref.style.top = "";
      }
      else{
        vref.style.top = "100%";
        vref.style.bottom = "";
      }
      if(isLeft){
        href.style.right = "100%";
        href.style.left = "";
      }
      else{
        href.style.left = "100%";
        href.style.right = "";
      }

    }


}
  



  useEffect(() => {


    let can = document.querySelector(".canvas");
    if(can){
      can.addEventListener("resize",onMutation);
      can.addEventListener("scroll",onMutation);
    }

    if (thisDom.current && prevDom.current != props.selectedTarget?.dom) {

    

      fadeInElement(thisDom.current, 200);
      if(props.selectedTarget)
        prevDom.current = props.selectedTarget.dom;
      else
        prevDom.current = null;
    }




    const resizeObserver = new ResizeObserver ((entries) => {
      onMutation();
     
    });
    const mutationObserver = new MutationObserver((entries) => {

      onMutation();
     
    });

    if (prevDom.current) {
      mutationObserver.observe(prevDom.current,{
        childList: false,
        subtree: false,
        attributes: true,
        characterData: true,
        attributeFilter: ["style"]
      });


      let canvas = document.querySelector(".canvas");
      resizeObserver.observe(prevDom.current);
      if(canvas){
        resizeObserver.observe(canvas);

      }
      
  
     

    }


    
    return () => {
     
        mutationObserver.disconnect();// .unobserve(prevDom.current);
        resizeObserver.disconnect();
      
    let can = document.querySelector(".canvas");
      if(can){
        can.removeEventListener("resize",onResize);
        can.removeEventListener("scroll",onMutation);
      }
    };



  });
  

  const getContainer = ()=>{

    if(!props.selectedTarget||!props.selectedTarget.dom)
      return null;

    const parent = props.selectedTarget.dom.parentElement?.closest(".hierarchy");
    if(parent){
      containerDom.current = (parent as HTMLElement)??null;
    }

  }

  const getOffsetBounds= (isLeft:boolean = true,isTop:boolean = true)=>{

    if(containerDom.current==null){
      getContainer();
    }

    if(!props.selectedTarget||containerDom.current==null)
      return {x:0,y:0};



    let containerBounds = containerDom.current.getBoundingClientRect();
    let targetBounds = props.selectedTarget.dom.getBoundingClientRect();

    const x = isLeft?targetBounds.left-containerBounds.left:containerBounds.right-targetBounds.right;
    const y = isTop?targetBounds.top-containerBounds.top:containerBounds.bottom-targetBounds.bottom;


    return {x:x,y:y};

  }

 

  if (props.selectedTarget == null||props.selectedTarget.layout==null)
  return null;



  let bounds = GetCanvasRelativeBounds(props.selectedTarget.dom);
  const comp = GetWBComponentByTypename(props.selectedTarget.layout.typename);

  if(bounds.width == 0 && bounds.height == 0){


    return null;
  }

  if(comp==null)
    return null;

    const horizontal = (comp.resizeType==ResizeableType.All||comp.resizeType ==ResizeableType.HorizontalOnly);
    let vertical = (comp.resizeType==ResizeableType.All||comp.resizeType ==ResizeableType.VerticalOnly);

    if(comp.typename===wBComponentTypeNames.section && props.screenSize === ScreenSize.Mobile){

      vertical = false;
    }
    const verticalClass = (vertical)?"":" no-resize";
    const horizontalClass =(horizontal)?"":" no-resize";
    const cornerClass = (vertical && horizontal)?"":" no-resize";





  if (props.selectedTarget ){

    let className = "hover-outline selected";
    if(props.editorState == EditorState.EditingContent)
      className+=" editing";

    const isAbsolute = getNodeRootStyleAttributeValue(props.selectedTarget.layout,props.screenSize,"position")=="absolute";


    if(isAbsolute){


        getContainer();

    }


    return (
      <>


      <div
        className={className}
        id="select-outline"
        ref={thisDom}
        key={props.selectedTarget.layout.id+"selected"}
        style={{
          left: bounds.left + "px",
          top: bounds.top + "px",
          width: bounds.width + "px",
          height: bounds.height + "px",
        }}
      >
   
        


{isAbsolute&&
<>

        <div className={"absolute-move-line horizontal "} ref={horizontalLineRef}


        
        ></div>
        <div className={"absolute-move-line vertical " } ref={verticalLineRef}

        
        ></div>

        <div className="absolute-move-handle top block-edit"
           onPointerDown={(e) => { e.stopPropagation(); props.startAbsMoveFunction(props.selectedTarget,e) }}
        
        >
          <MoveIcon/>
        </div>

        <div className="absolute-move-handle right block-edit"
           onPointerDown={(e) => { e.stopPropagation(); props.startAbsMoveFunction(props.selectedTarget,e) }}
        
        >
          <MoveIcon/>
        </div>
        <div className="absolute-move-handle bottom block-edit"
           onPointerDown={(e) => { e.stopPropagation(); props.startAbsMoveFunction(props.selectedTarget,e) }}
        
        >
          <MoveIcon/>
        </div>
        <div className="absolute-move-handle left block-edit"
           onPointerDown={(e) => { e.stopPropagation(); props.startAbsMoveFunction(props.selectedTarget,e) }}
        
        >
          <MoveIcon/>
        </div>

</>
}

<div className={"dot t"+verticalClass}>  </div>
        <div className={"dot r"+horizontalClass}>  </div>
        <div className={"dot l" +horizontalClass}></div>
        <div className={"dot b"+verticalClass}> </div>
        
        <div className={"dot tr"+cornerClass}> </div>
        <div className={"dot br"+cornerClass}>  </div>
        <div className={"dot bl"+cornerClass}></div>
        <div className={"dot tl"+cornerClass}></div>
        {horizontal && 
          <>
          <div className="resize-block left block-edit"
            onPointerDown={(e) => { e.stopPropagation(); props.startResizeFunction(props.selectedTarget, ResizeType.Left,e) }} ></div>
        
          <div className="resize-block right block-edit"
            onPointerDown={(e) => { e.stopPropagation(); props.startResizeFunction(props.selectedTarget, ResizeType.Right,e) }} ></div>
            </>
        }
        {vertical &&
          <>
        <div className="resize-block top block-edit"
          onPointerDown={(e) => { e.stopPropagation(); props.startResizeFunction(props.selectedTarget, ResizeType.Top,e) }}></div>
        <div className="resize-block bottom block-edit"
          onPointerDown={(e) => { e.stopPropagation(); props.startResizeFunction(props.selectedTarget, ResizeType.Bottom,e) }} ></div>
          </>
        }
        {vertical && horizontal &&
          <>
        <div className="resize-block top-left block-edit"
          onPointerDown={(e) => { e.stopPropagation(); props.startResizeFunction(props.selectedTarget, ResizeType.TopLeft,e) }}></div>
        <div className="resize-block top-right block-edit"
          onPointerDown={(e) => { e.stopPropagation(); props.startResizeFunction(props.selectedTarget, ResizeType.TopRight,e) }}></div>
        <div className="resize-block bottom-left block-edit"
          onPointerDown={(e) => { e.stopPropagation(); props.startResizeFunction(props.selectedTarget, ResizeType.BottomLeft,e) }}></div>
        <div className="resize-block bottom-right block-edit"
          onPointerDown={(e) => { e.stopPropagation(); props.startResizeFunction(props.selectedTarget, ResizeType.BottomRight,e) }}></div>
          </>
        }
      </div>
      </>
    );
    
  }
  else {
    return null;
  }

}


function MoveIcon(){
  return <svg xmlns="http://www.w3.org/2000/svg" height="1em" viewBox="0 0 512 512" fill="currentColor"><path d="M273 7c-9.4-9.4-24.6-9.4-33.9 0L167 79c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l31-31V232H81.9l31-31c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0L7 239c-9.4 9.4-9.4 24.6 0 33.9l72 72c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-31-31H232V430.1l-31-31c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l72 72c9.4 9.4 24.6 9.4 33.9 0l72-72c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-31 31V280H430.1l-31 31c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l72-72c9.4-9.4 9.4-24.6 0-33.9l-72-72c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l31 31H280V81.9l31 31c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9L273 7z"/></svg>
}